import {
  type UseInfiniteQueryOptions,
  useInfiniteQuery,
} from '@tanstack/react-query';
import { concat } from 'lodash';
import { ILocationTag, PaginationResponse } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationOwnerTags = (
  filters: string[] = [],
  overrideQuerySetting?: UseInfiniteQueryOptions<
    PaginationResponse<ILocationTag[]>
  >,
) => {
  return useInfiniteQuery({
    queryKey: queryKeys.locationOwnerTags.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchLocationOwnerTags(concat(filters, [`page=${pageParam}`])),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    ...overrideQuerySetting,
  });
};

const fetchLocationOwnerTags = async (
  filters: string[] = [],
): Promise<PaginationResponse<ILocationTag[]>> => {
  const url = `/locationOwnerTags${generateQuery([], filters)}`;
  const response = await requestCCApi({ url });

  return {
    data: response.data,
    totalPages: response.totalPages ?? 0,
    totalCount: response.totalCount ?? 0,
  } as PaginationResponse<ILocationTag[]>;
};
